// extracted by mini-css-extract-plugin
export default {"discountName":"DiscountEntry_discountName__BLzvj","discountPrice":"DiscountEntry_discountPrice__Fszp1"};